module.exports = __webpack_public_path__ + "static/img/andrioIos_cur.ff47843.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/andrioIos_cur.png
// module id = mnXH
// module chunks = 0